export const accessors = {
  xAccessor: (d: any) => d.x,
  yAccessor: (d: any) => d.y,
};
